import { combineReducers } from 'redux';

import ui from './ui';
import user from './user';

const commonReducer = combineReducers({
  ui,
  user,
});

export default commonReducer;
